import { createReducer, on } from '@ngrx/store';
import { IDigitalProduct } from '../models/digitalProduct.model';
import { digitalProductActions } from './digitalProduct.actions';
import { DigitalProductState } from './digitalProduct.state';

export const initialDigitalProductState: DigitalProductState = {
    currentDigitalProduct: {} as IDigitalProduct,
    digitalProductList: [] as IDigitalProduct[]
};

export const digitalProductReducer = createReducer(
    initialDigitalProductState,

    on(digitalProductActions.getDigitalProductsSuccess, (state, { digitalProductList }) => ({
        ...state,
        digitalProductList
    })),

    on(digitalProductActions.getDigitalProductSuccess, (state, { digitalProduct }) => ({
        ...state,
        currentDigitalProduct: digitalProduct
    }))
);
